import BbModal from './BbModal.vue';

export default BbModal;
